<div *ngIf="!param.colDef.isTooltip" class="custom-tooltip">{{ param.value }}</div>
<div *ngIf="param.colDef.isTooltip" class="custom-tooltip">
     <div class="d-flex flex-column align-self-start">
        <span class="mb-2 align-self-start">Qty includes:</span>
        <span class="align-self-start">+ Inbound</span>
        <span class="align-self-start">+ Local Stock</span>
        <span class="align-self-start">+ Outbound Stock</span>
        <span class="align-self-start">+ FBA Stock</span>
        <span class="align-self-start">- Reserved Stock</span>
     </div>
</div>